/* eslint-disable max-classes-per-file */
import { LocalTimeRange, Uuid } from '@ftr/contracts/type/shared'
import { LocalDate, LocalTime } from '@js-joda/core'
import { HearingSectionFormModel } from '../../lib'
import { RealTimePlaybackKey } from '../real-time-playback'

export class CreateHearingSectionCommand {
  static readonly type = '[Annotations] Create Hearing Section'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly courtSystemId: Uuid,
    readonly startTime: LocalTime,
    readonly recordingDate: LocalDate,
    readonly locationId: Uuid,
    readonly conflictResolutionToken?: string,
  ) {}
}

export class UpdateHearingSectionCommand {
  static readonly type = '[Annotations] Update Hearing Section'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingSectionId: Uuid,
    readonly hearingSection: HearingSectionFormModel,
    readonly recordingDate: LocalDate,
    readonly locationId: Uuid,
    readonly conflictResolutionToken?: string,
  ) {}
}

export class DeleteHearingSectionCommand {
  static readonly type = '[Annotations] Delete Hearing Section'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly id: Uuid,
    readonly courtSystemId: Uuid,
  ) {}
}

export class FetchHearingSectionsCommand {
  static readonly type = '[Annotations] Fetch Hearing Sections'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly courtSystemId: Uuid,
  ) {}
}

export class ListenForHearingSectionUpdatesCommand {
  static readonly type = '[Annotations] Listen for Hearing Section Updates'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly courtSystemId: Uuid,
  ) {}
}

export class StopListeningForHearingSectionUpdatesCommand {
  static readonly type = '[Annotations] Stop Listening for Hearing Section Updates'
  constructor(readonly playbackKey: RealTimePlaybackKey) {}
}

export class UpdateAnnotationBoundariesCommand {
  static readonly type = '[Annotations] Update Annotation Boundaries'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly annotationBoundaries: LocalTimeRange[],
  ) {}
}

export class SetLiveLocalTimeCommand {
  static readonly type = '[Annotations] Set Live LocalTime'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly liveLocalTime: LocalTime | undefined,
  ) {}
}

export class SetHearingSectionToOngoingCommand {
  static readonly type = '[Annotations] Set Hearing Section To Ongoing'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingSectionId: Uuid,
    readonly recordingDate: LocalDate,
    readonly locationId: Uuid,
  ) {}
}
